module.exports = __webpack_public_path__ + "img/p8.40557bd9.jpg";